import React from "react";
import Paragraph from "../Paragraph";
import { classes } from "../utils/classes";

const HeroLead = ({ className = "", ...props }) => {
	return <Paragraph className={classes("section-hero__lead", className)} {...props} />;
};

HeroLead.propTypes = {
	...Paragraph.propTypes,
};

export default HeroLead;
